define('responsive-gameday-scoreboard/src/js/GameDayScoreboardGameExtender',['require','exports','module','GameExtender/GameExtender','es6ish-class/es6ish-class','moment'],function(require,exports,module){
    var GameExtender = require( 'GameExtender/GameExtender' ),
        es6ishClass = require( 'es6ish-class/es6ish-class' ),
        moment = require('moment'),
        Superclass;

    function GameDayScoreboardGameExtender(){
        Superclass.constructor.call(this);
    }


    es6ishClass(GameDayScoreboardGameExtender)
        .extendsFrom(GameExtender)
        .define({
            addMessage : function(game) {
                Superclass.addMessage.call(this, game);
                if(game.status.is_before_game){
                 var game_number = game.game_number = game.id.substr(-1);
                 var is_doubleheader = (game_number === '2');
                 var is_tbd        = (game.time === '3:33' && game.ampm === 'AM');
                
                 game.message = game.time + " " + game.ampm;
                
                 if (is_tbd) {
                  game.message = (is_doubleheader) ? "Gm " + game_number : "TBD"
                 } 
                }
                
                // No hitter/perfect game
                if (game.status.is_perfect_game === "Y" || game.status.is_perfect_game === true) {
                  game.flagText = "Perfect Game";
                } else if (game.status.is_no_hitter === "Y" || game.status.is_no_hitter === true) {
                  game.flagText = "No-Hitter";
                }
                
                
            },
            addCSSHooks : function(game) {
                Superclass.addCSSHooks.call(this, game);

                // Class used on secondary line below teams
                if(game.status.is_after_game || game.status.is_over) {
                    game.messageCSSClass = 'finalState';
                } else if (game.status.is_in_progress) {
                    game.messageCSSClass = 'inningState';
                } else {
                    game.messageCSSClass = 'otherState';
                }

                // Men on base CSS
                var mobVal = "mob";
                if (game.runners_on_base.runner_on_1b) { 
                    mobVal += "First"; 
                }
                if (game.runners_on_base.runner_on_2b) { 
                    mobVal += "Second"; 
                }
                if (game.runners_on_base.runner_on_3b) { 
                    mobVal += "Third"; 
                }

                game.menOnBaseCSSClass = mobVal;

                // Inning arrow
                if(game.status.inning_state === "Top" || game.status.inning_state === "Middle") {
                    game.inningArrow = "upArrow";
                } else if (game.status.inning_state === "Bottom" || game.status.inning_state === "End") {
                    game.inningArrow = "dnArrow";
                }

                // Winner/Loser team
                if(game.status.is_final) {
                    game.awayWinnerLoser = game.away === game.teams.winning ? "winner" : "loser";
                    game.homeWinnerLoser = game.home === game.teams.winning ? "winner" : "loser";
                } else {
                    // Carrying over old behavior/styles..
                    game.awayWinnerLoser = "winner";
                    game.homeWinnerLoser = "winner";
                }

                // Mark current game
                if(location.hash.indexOf(game.gameday) >= 0) {
                    game.isHighlightedGame = "highlightedGame";
                }
                
                if (game.status.o === "0") {
                  game.statusOut_none = true;
                  game.statusOut_two = false;
                  game.statusOut_one = false;
                } else if (game.status.o === "1") {
                  game.statusOut_none = false;
                  game.statusOut_two = false;
                  game.statusOut_one = true;
                }  else if (game.status.o === "2") {
                  game.statusOut_none = false;
                  game.statusOut_two = true;
                  game.statusOut_one = false;
                }
                
                if (game.resume_date !== "") {
                  game.resume_date_formatted = moment(game.resume_date).format('MMM D');
                }
                
                
                
            }
        })

    Superclass=GameDayScoreboardGameExtender.superclass;

    return GameDayScoreboardGameExtender;
});
